module.exports = __webpack_public_path__ + "static/img/Stu4@2x.c28dfc10.png";